export default {
	setTeams(state, payload) {
		state.teams = payload;
	},
	deletedTeam(state, payload) {
		const deletedTeam = state.teams.find((team) => team.id === payload);
		const index = state.teams.indexOf(deletedTeam);
		state.teams.splice(index, 1);
	},
	setLineUps(state, payload) {
		state.lineUps = payload
	},
}